import { useEffect, useState } from "react";
import "./App.scss";
import SysRoutes from "./routes/Routes";
import "react-datepicker/dist/react-datepicker.css";
import { Toaster } from "react-hot-toast";
import "@aws-amplify/ui-react/styles.css";
import "./amplify-config";
import { useIdleTimer } from "react-idle-timer";
import Modal from "./components/modals/Modal.tsx";
import { signOutUser } from "./services/api";
import { getConfig } from "./services/util.js";

const timeout = 600000;
const promptBeforeIdle = 10000;
function App() {
  const [open, setOpen] = useState(false);
  const [state, setState] = useState("Active");
  const [remaining, setRemaining] = useState(timeout);
  const isLoggedIn = localStorage.getItem("user") ? true : false;

  const onIdle = () => {
    if (isLoggedIn) {
      setState("Idle");
      setOpen(false);
    }
  };

  const onActive = () => {
    if (isLoggedIn) {
      setState("Active");
      setOpen(false);
    }
  };

  const onPrompt = () => {
    if (isLoggedIn) {
      setState("Prompted");
      setOpen(true);
    }
  };

  const { getRemainingTime, activate } = useIdleTimer({
    onIdle: isLoggedIn ? onIdle : () => {},
    onActive,
    onPrompt,
    timeout: isLoggedIn ? timeout : 0, // disable idle when not logged in
    promptBeforeIdle: isLoggedIn ? promptBeforeIdle : -1,
    throttle: 500,
  });

  const handleStillHere = () => {
    activate();
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  });

  const fetchConfig = async () => {
    try {
      const { data } = await getConfig();
      localStorage.setItem("config", JSON.stringify(data));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (state === "Idle" && isLoggedIn) {
      signOutUser();
    }

    if (isLoggedIn) {
      fetchConfig();
    }
  }, [state, isLoggedIn]);

  useEffect(() => {
    const theme = localStorage.getItem("theme");
    if (theme) {
      document.documentElement.setAttribute("data-theme", theme);
    }
  }, []);
  return (
    <div>
      <SysRoutes />
      <Toaster
        position="top-right"
        containerStyle={{
          zIndex: 99999999,
        }}
        toastOptions={{
          duration: 4000,
          success: {
            style: {
              background: "var(--toast-success-bg)",
              zIndex: 999,
            },
          },
          error: {
            style: {
              background: "var(--toast-error-bg)",
              zIndex: 999,
            },
          },
          style: {
            borderRadius: "8px",
            maxWidth: "366px",
            minHeight: "48px",
            boxShadow: "none",
            fontFamily: "Inter",
            fontWeight: 500,
            fontSize: "14px",
            lineHeight: "17px",
            letterSpacing: "0.01em",
            color: "var(--toast-text)",
            textAlign: "left",
            flex: "unset",
            zIndex: 999,
          },
        }}
      />

      <Modal
        isOpen={open}
        onCancel={() => setOpen(false)}
        title="Are you still here?"
        size="sm"
      >
        <p
          className="mb-8"
          style={{ textAlign: "center", fontSize: "16px", fontWeight: "500" }}
        >
          Logging out in {remaining} seconds
        </p>

        <button
          onClick={handleStillHere}
          className="btn btn--secondary btn--sm btn--block"
        >
          I'm still here
        </button>
      </Modal>
    </div>
  );
}

export default App;
